define('cartware/components/Holepunch',[
	"jquery",
	"./Utilities"
], function(
	$,
	Utils
) {
	function Holepunch() {
		this.url		= Utils.getPath(window, "gigaset.holepunch.url");
		this.handle		= Utils.getPath(window, "gigaset.request.action");
		this.product	= Utils.getPath(window, "gigaset.request.product");
		this.category	= Utils.getPath(window, "gigaset.request.category");

		this.deferred	= $.Deferred();

		if (Utils.getPath(window, "gigaset.holepunch.active")) {
			$($.proxy(this.load, this));
		}
	}

	Holepunch.prototype = {
		url:		null,
		handle:		null,
		product:	null,
		category:	null,

		deferred:	null,

		load: function() {
			// fresh holepunch
			if (this.deferred.state() !== "pending") {
				this.deferred = $.Deferred();
			}

			var xhr = $.ajax({
				url: this.url,
				type: "POST",
				dataType: "JSON",
				data: {
					handle:		this.handle,
					product:	this.product,
					category:	this.category,
					info:		Utils.getPath(window, "gigaset.holepunch.info") || {}
				}
			});

			xhr.done($.proxy(function(data) {
				this.deferred.resolveWith(null, [data]);
				this.fill(data);
			}, this));

			xhr.fail($.proxy(this._onError, this));

			return this;
		},

		ready: function(cb) {
			this.deferred.then(cb);
		},

		fill: function(data) {
			if ("blocks" in data) {
				$.each(data.blocks, function(index, value) {
					$('#' + index.replace(/(:|\.|\[|\])/g, "\\$1")).replaceWith(value);
				});
			}
		},

		_onError: function(jqXHR, textStatus, errorThrown) {
			if ("console" in window && "undefined" !== typeof console.error) {
				console.error(errorThrown);
				console.log(jqXHR);
			}
		}
	};

	return (new Holepunch());
});
